let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jhhI3")).then(() => parcelRequire('aFAJl'));